<template>
  <div class="index">
    <van-nav-bar title="淋巴瘤诊疗观念调研1" fixed left-arrow @click-left="$router.go(-1)" />
    <div class="index-head">淋巴瘤诊疗观念调研1</div>
    <!--  -->
    <el-form :model="form" :rules="rules" ref="ruleForm" label-width="105px" class="form" label-position="left">
      <div class="box">
        <div class="box-head">
          <div class="box-head-title">
            为了进一步推动CAR-T疗法在LBCL治疗中的规范化管理，特诚邀血液肿瘤领域的各位专业医师参与本次调研。本问卷旨在了解当前国内CAR-T细胞治疗的临床应用现状，以及医师们对LBCL治疗的诊疗观念。</div>
          <ul class="box-head-ul">
            <li class="box-head-ul-li">1. 本次调研所有信息仅用于学术研究，不涉及商业用途。</li>
            <li class="box-head-ul-li">2. 请根据实际情况作答，确保所填信息的完整性和准确性，请勿虚构数据或歪曲事实。</li>
            <li class="box-head-ul-li">3. 患者的个人信息将匿名处理，确保隐私安全。</li>
            <li class="box-head-ul-name">本问卷预计耗时约20分钟，感谢您的耐心填写。</li>
          </ul>
          <div>
            <div class="form-head-input">
              <el-form-item class="form-dis-item" label="医生姓名：" prop="name">
                <el-input v-model="form.name" placeholder="请输入医生姓名" :disabled="true" />
              </el-form-item>
              <el-form-item class="form-dis-item" label="所在医院：" prop="hospital">
                <el-input v-model="form.hospital" placeholder="请输入所在医院" :disabled="true" />
              </el-form-item>
              <el-form-item class="form-dis-item" label="所在科室：" prop="department">
                <el-input v-model="form.department" placeholder="请输入所在科室" :disabled="true" />
              </el-form-item>
              <el-form-item label="职称：" prop="title" class="form-dis-item-left">
                <el-input v-model="form.title" placeholder="请输入职称" :disabled="true" />
              </el-form-item>
            </div>
            <div class="form-dis-box">
              <el-form-item label="医院级别：" prop="rank">
                <el-radio-group v-model="form.rank" class="form-dis-radio" :disabled="true">
                  <el-radio :label="1">一级</el-radio>
                  <el-radio :label="2">二级</el-radio>
                  <el-radio :label="3">三级</el-radio>
                  <el-radio :label="4" style="margin-top: 15px;">其他</el-radio>
                </el-radio-group>
              </el-form-item>
              <div class="form-dis-box-radio">
                <el-form-item prop="rank_input" v-if="form.rank == 4">
                  <el-input v-model="form.rank_input" placeholder="请输入内容" :disabled="true" />
                </el-form-item>
              </div>
            </div>
            <div class="form-dis-box">
              <el-form-item label="医院性质：" prop="property" style="margin-bottom: 0;">
                <el-radio-group v-model="form.property" class="form-dis-radio2" :disabled="true">
                  <el-radio :label="1" style="margin-right: 13px;">综合性医院</el-radio>
                  <el-radio :label="2">肿瘤专科医院</el-radio>
                  <el-radio :label="3" style="margin-right: 200px;margin-top: 15px;">民营/私立医院</el-radio>
                  <el-radio :label="4" style="margin-top: 15px;">其他</el-radio>
                </el-radio-group>
              </el-form-item>
              <div class="form-dis-box-radio2">
                <el-form-item prop="property_input" v-if="form.property == 4">
                  <el-input v-model="form.property_input" placeholder="请输入内容" :disabled="true" />
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
        <!-- 1 -->
        <div class="form-item">
          <el-form-item label="1、您对淋巴瘤的早期筛查有何建议？(可多选)" prop="lymph_propose_checkbox" ref="lymph_propose_checkbox"
            class="box-dis">
            <el-checkbox-group v-model="form.lymph_propose_checkbox" :disabled="true">
              <el-checkbox label="1" name="type">应加强早期筛查，尤其是高危人群</el-checkbox>
              <el-checkbox label="2" name="type">早期筛查应结合临床症状</el-checkbox>
              <el-checkbox label="3" name="type">目前早期筛查技术尚不成熟，不建议大规模推广</el-checkbox>
              <el-checkbox label="4" name="type">依赖现有筛查方法，暂无新的建议</el-checkbox>
              <el-checkbox style="margin-bottom: 0;" label="5" name="type">其他</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item class="box-dis-input box-dis2" prop="lymph_propose_checkbox_input"
            ref="lymph_propose_checkbox_input" v-if="form.lymph_propose_checkbox.includes('5') == true">
            <el-input v-model="form.lymph_propose_checkbox_input" placeholder="请输入内容" :disabled="true" />
          </el-form-item>
        </div>
        <!-- 2 -->
        <div class="form-item form-item-error">
          <el-form-item label="2、您在淋巴瘤治疗中最常采用的治疗方案是？" prop="lymph_scheme_radio" ref="lymph_scheme_radio" class="box-dis">
            <el-radio-group v-model="form.lymph_scheme_radio" :disabled="true">
              <el-radio :label="1">化疗</el-radio>
              <el-radio :label="2">靶向治疗</el-radio>
              <el-radio :label="3">免疫治疗</el-radio>
              <el-radio :label="4">CAR-T治疗</el-radio>
              <el-radio :label="5" style="margin: 20px 0 12px 0;">综合治疗</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <!-- 3 -->
        <div class="form-item form-item-error">
          <el-form-item label="3、在淋巴瘤患者中，您认为诊断的最大挑战是什么？" prop="lymph_challenge_radio" ref="lymph_challenge_radio"
            class="box-dis">
            <el-radio-group v-model="form.lymph_challenge_radio" :disabled="true">
              <el-radio :label="1">病理分类</el-radio>
              <el-radio :label="2">基因检测结果解读</el-radio>
              <el-radio :label="3">病情复杂性</el-radio>
              <el-radio :label="4" style="margin: 20px 0 12px 0;">其他</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item class="box-dis-input box-dis2" prop="lymph_challenge_radio_input"
            ref="lymph_challenge_radio_input" v-if="form.lymph_challenge_radio == 4">
            <el-input v-model="form.lymph_challenge_radio_input" placeholder="请输入内容" :disabled="true" />
          </el-form-item>
        </div>
        <!-- 4 -->
        <div class="form-item">
          <el-form-item label="4、您认为免疫治疗与传统化疗相比的优势是什么？（可多选）" prop="lymph_superiority_checkbox"
            ref="lymph_superiority_checkbox" class="box-dis">
            <el-checkbox-group v-model="form.lymph_superiority_checkbox" :disabled="true">
              <el-checkbox label="1" name="type">更高的疗效</el-checkbox>
              <el-checkbox label="2" name="type">副作用更小</el-checkbox>
              <el-checkbox label="3" name="type">更适合老年患者</el-checkbox>
              <el-checkbox style="margin-bottom: 0;" label="4" name="type">其他</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item class="box-dis-input box-dis2" prop="lymph_superiority_checkbox_input"
            ref="lymph_superiority_checkbox_input" v-if="form.lymph_superiority_checkbox.includes('4') == true">
            <el-input v-model="form.lymph_superiority_checkbox_input" placeholder="请输入内容" :disabled="true" />
          </el-form-item>
        </div>
        <!-- 5 -->
        <div class="form-item">
          <el-form-item label="5、针对年轻患者（如20-40岁），您在治疗方案上是否有所不同？" prop="lymph_identical_radio" ref="lymph_identical_radio"
            class="box-dis">
            <el-radio-group v-model="form.lymph_identical_radio" :disabled="true">
              <el-radio :label="1">偏向更为激进的治疗</el-radio>
              <el-radio :label="2" style="margin: 20px 0 0px 0;">选择更为保守的治疗</el-radio>
              <el-radio :label="3" style="margin: 20px 0 13px 0;">基本与其他年龄段患者相同</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <!-- 6 -->
        <div class="form-item form-item-error">
          <el-form-item label="6、在治疗淋巴瘤患者时，您会主动推荐CAR-T治疗吗？" prop="lymph_cartreat_radio" ref="lymph_cartreat_radio"
            class="box-dis">
            <el-radio-group v-model="form.lymph_cartreat_radio" :disabled="true">
              <el-radio :label="1">经常</el-radio>
              <el-radio :label="2">偶尔</el-radio>
              <el-radio :label="3">很少</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <!-- 7 -->
        <div class="form-item form-item-error">
          <el-form-item label="7、您对国内淋巴瘤诊疗指南的认可程度如何？" prop="lymph_level_radio" ref="lymph_level_radio" class="box-dis">
            <el-radio-group v-model="form.lymph_level_radio" :disabled="true">
              <el-radio :label="1">非常认可</el-radio>
              <el-radio :label="2">较认可</el-radio>
              <el-radio :label="3">有待完善</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <!-- 8 -->
        <div class="form-item form-item-error">
          <el-form-item label="8、您对当前淋巴瘤治疗疗效评估的工具是否满意？" prop="lymph_satisfied_radio" ref="lymph_satisfied_radio"
            class="box-dis">
            <el-radio-group v-model="form.lymph_satisfied_radio" :disabled="true">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="2">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <!-- 9 -->
        <div class="form-item form-item-error">
          <el-form-item label="9、您认为淋巴瘤患者的随访管理中，最大挑战是什么？" prop="lymph_flup_radio" ref="lymph_flup_radio" class="box-dis">
            <el-radio-group v-model="form.lymph_flup_radio" :disabled="true">
              <el-radio :label="1">患者依从性差</el-radio>
              <el-radio :label="2">医疗资源不足</el-radio>
              <el-radio :label="3">缺乏规范化管理</el-radio>
              <el-radio :label="4" style="margin: 20px 0 12px 0;">其他</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item class="box-dis-input box-dis2" prop="lymph_flup_radio_input" ref="lymph_flup_radio_input"
            v-if="form.lymph_flup_radio == 4">
            <el-input v-model="form.lymph_flup_radio_input" placeholder="请输入内容" :disabled="true" />
          </el-form-item>
        </div>
        <!-- 10 -->
        <div class="form-item form-item-error">
          <el-form-item label="10、您认为国内淋巴瘤治疗领域最需要突破的是什么？" prop="lymph_through_radio" ref="lymph_through_radio"
            class="box-dis">
            <el-radio-group v-model="form.lymph_through_radio" :disabled="true">
              <el-radio :label="1">新药研发</el-radio>
              <el-radio :label="2">早期诊断技术</el-radio>
              <el-radio :label="3">优化治疗方案</el-radio>
              <el-radio :label="4" style="margin: 20px 0 12px 0;">降低治疗费用</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <!-- 11 -->
        <div class="form-item form-item-error">
          <el-form-item label="11、是否关注过淋巴瘤患者的心理健康？" prop="lymph_health_radio" ref="lymph_health_radio" class="box-dis">
            <el-radio-group v-model="form.lymph_health_radio" :disabled="true">
              <el-radio :label="1">经常关注</el-radio>
              <el-radio :label="2">偶尔关注</el-radio>
              <el-radio :label="3">很少关注</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <!-- 12 -->
        <div class="form-item form-item-error">
          <el-form-item label="12、您认为当前淋巴瘤领域的多学科协作情况如何？" prop="lymph_cooperatewith_radio" ref="lymph_cooperatewith_radio"
            class="box-dis">
            <el-radio-group v-model="form.lymph_cooperatewith_radio" :disabled="true">
              <el-radio :label="1">非常高效</el-radio>
              <el-radio :label="2">较高效</el-radio>
              <el-radio :label="3">有待提升</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <!-- 13 -->
        <div class="form-item form-item-error">
          <el-form-item label="13、您在临床工作中是否会推荐患者参与临床试验？" prop="lymph_trial_radio" ref="lymph_trial_radio" class="box-dis">
            <el-radio-group v-model="form.lymph_trial_radio" :disabled="true">
              <el-radio :label="1">经常</el-radio>
              <el-radio :label="2">偶尔</el-radio>
              <el-radio :label="3">很少</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <!-- 14 -->
        <div class="form-item form-item-error">
          <el-form-item label="14、在淋巴瘤治疗中，患者是否普遍接受基因检测？" prop="lymph_gencheck_radio" ref="lymph_gencheck_radio"
            class="box-dis">
            <el-radio-group v-model="form.lymph_gencheck_radio" :disabled="true">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="2">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <!-- 15 -->
        <div class="form-item">
          <el-form-item label="15、您对未来淋巴瘤治疗的发展趋势有何期待？（开放题）" prop="expectation" ref="expectation" class="box-dis">
            <div class="box-bottom-15">
              <el-input style="width: 100%;" type="textarea" v-model="form.expectation" placeholder="请输入内容"
                :disabled="true" />
            </div>
          </el-form-item>
        </div>
        <!-- 16 -->
        <!-- <div class="form-item"></div> -->
        <!-- 结束 -->
        <div class="dibu">
          <div class="dibu-img"><img src="@/assets/image/survey/anquan.png"></div>
          <div class="dibu-name">隐私保护</div>
        </div>
        <div style="margin-bottom: 10px;">您提供的个人信息和回答将仅用于统计分析和研究。</div>
        <div>非常感谢您抽出宝贵时间参与本次调查，您的意见和建议对我们非常重要！</div>
        <!-- 按钮 -->
        <!-- <div class="btn">
          <el-form-item class="btn-form">
            <el-button style="width: 100%; border-radius:18px;" type="primary"
              @click="submitForm('ruleForm')">提交</el-button>
          </el-form-item>
        </div> -->
      </div>
    </el-form>
    <!--  -->
  </div>
</template> 
<script>
export default {
  name: 'survey1',
  data() {
    return {
      form: {
        name: '', //姓名
        hospital: '',//医院  
        department: '',//科室
        title: '',//职称 
        rank: '',//级别
        rank_input: '',//级别其他
        property: '',//性质 
        property_input: '',//性质其他

        lymph_propose_checkbox: [],//建议
        lymph_propose_checkbox_input: '',//建议输入框
        lymph_scheme_radio: '',//方案
        lymph_challenge_radio: '',//挑战
        lymph_challenge_radio_input: '',//挑战输入框 
        lymph_superiority_checkbox: [],//优势 
        lymph_superiority_checkbox_input: '',//优势输入框
        lymph_identical_radio: '',//是否不同
        lymph_cartreat_radio: '',//car-t治疗
        lymph_level_radio: '',//程度
        lymph_satisfied_radio: '',//满意
        lymph_flup_radio: '',//程度 
        lymph_flup_radio_input: '',//挑战
        lymph_through_radio: '',//突破 
        lymph_health_radio: '',//健康
        lymph_cooperatewith_radio: '',//协作
        lymph_trial_radio: '',//实验
        lymph_gencheck_radio: '',//检测
        expectation: '',//期待  
      },
      rules: {
        name: [
          { required: true, message: '请输入医生姓名', trigger: 'blur' },
        ],
        hospital: [
          { required: true, message: '请输入所在医院', trigger: 'blur' }
        ],
        department: [
          { required: true, message: '请输入所在科室', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '请输入所职称', trigger: 'blur' }
        ],
        rank: [
          { required: true, message: '请选择医院级别', trigger: 'change' }
        ],
        rank_input: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ],
        property: [
          { required: true, message: '请选择医院性质', trigger: 'change' }
        ],
        property_input: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ],
        //---------
        lymph_propose_checkbox: [
          { required: true, message: '请选择建议', trigger: 'change' }
        ],
        lymph_propose_checkbox_input: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ],
        lymph_scheme_radio: [
          { required: true, message: '请输入方案', trigger: 'change' }
        ],
        lymph_challenge_radio: [
          { required: true, message: '请选择挑战', trigger: 'change' }
        ],
        lymph_challenge_radio_input: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ],
        lymph_superiority_checkbox: [
          { required: true, message: '请选择优势', trigger: 'change' }
        ],
        lymph_superiority_checkbox_input: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ],
        lymph_identical_radio: [
          { required: true, message: '请选择是否有所不同', trigger: 'change' }
        ],
        lymph_cartreat_radio: [
          { required: true, message: '请选择是否会主动推荐CAR-T治疗', trigger: 'change' }
        ],
        lymph_level_radio: [
          { required: true, message: '请选择认可程度', trigger: 'change' }
        ],
        lymph_satisfied_radio: [
          { required: true, message: '请选择是否有满意', trigger: 'change' }
        ],
        lymph_flup_radio: [
          { required: true, message: '请选择最大挑战', trigger: 'change' }
        ],
        lymph_flup_radio_input: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ],
        lymph_through_radio: [
          { required: true, message: '请选择需要突破的是什么', trigger: 'change' }
        ],
        lymph_health_radio: [
          { required: true, message: '请选择需患者的心理健康', trigger: 'change' }
        ],
        lymph_cooperatewith_radio: [
          { required: true, message: '请选择协作情况如何', trigger: 'change' }
        ],
        lymph_trial_radio: [
          { required: true, message: '请选择是否会推荐患者参与临床试验', trigger: 'change' }
        ],
        lymph_gencheck_radio: [
          { required: true, message: '请选择患者是否普遍接受基因检测', trigger: 'change' }
        ],
        expectation: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ],
      }
    }
  },
  created() {
    this.getecholist()
  },
  methods: {
    // 滚动条定位到第一个校验失败的div的位置
    locateToErr() {
      setTimeout(() => {
        let errorDiv = document.getElementsByClassName("is-error");
        errorDiv[0].scrollIntoView();
      }, 0);
    },
    //提交    
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitApi()
        } else {
          // this.locateToErr();  
          console.log('error submit!!');
          return false;
        }
      });
    },
    //提交接口
    async submitApi() {
      const { data: data } = await this.$http.post("/survey/info", { id: this.$route.query.id, form: this.form });
      console.log(data);
      this.$toast(data.message);
      this.$router.push({ path: "survey" });
    },
    //回显数据 
    async getecholist() {
      const { data: data } = await this.$http.get("/survey/info", { params: { id: this.$route.query.id } });
      this.form = data.data
    },
  },
}    
</script>
<style scoped>
.index {
  position: relative;
  left: -15px;
  width: 108.8%;
}

.index-head {
  position: relative;
  width: 375px;
  height: 96px;
  background: url(@/assets/image/survey/head-bgc.png) no-repeat center 0px;
  background-position: center 0px;
  background-size: cover;

  color: #130F0F;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}

.box {
  position: relative;
  /* top: -20px; */
  left: 0;
  background-color: #F6F8FF;
  width: 100%;
  box-shadow: 0px 0px 6px 1px #A4C4F1;
  border-radius: 15px 15px 0px 0px;
  min-height: calc(100vh - 142px);
  padding: 20px 15px;
  overflow: hidden;
}

.box-head {
  padding: 20px 12px;
  width: 100%;
  background-color: #fff;
  border-radius: 6px;
}

.box-head-title {
  color: #2B2B2B;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 25px;
}

.box-head-ul {}

.box-head-ul-li {
  color: #2B2B2B;
  font-size: 14px;
  margin-bottom: 22px;
  padding-left: 4px;
}

.box-head-ul-name {
  color: #2B2B2B;
  font-size: 14px;
  font-weight: 600;
  margin-top: 10px;
  margin-bottom: 30px;
}

.form-head-input>>>.el-input__inner {
  /* width: 120px; */
  width: 60%;
  border-radius: 0 !important;
  border-top: 0 !important;
  border-left: 0 !important;
  border-right: 0 !important;
  height: 20px !important;
  padding: 0 !important;
  padding-left: 3px !important;
  border-color: #130F0F;
}

.form-dis-radio {
  display: flex;
  flex-wrap: wrap;
}

.form-dis-radio>>>.el-radio {
  margin-right: 20px;
}

.form-dis-box {
  position: relative;
}

.form-dis-box-radio {
  position: absolute;
  top: 27px;
  right: -20px;
}

.form-dis-box-radio>>>.el-input__inner {
  /* width: 120px; */
  width: 80%;
  border-radius: 0 !important;
  border-top: 0 !important;
  border-left: 0 !important;
  border-right: 0 !important;
  height: 20px !important;
  padding: 0 !important;
  padding-left: 3px !important;
}

.form-dis-box-radio>>>.el-form-item__content {
  line-height: 20px !important;
}

.form-dis-box-radio2 {
  position: absolute;
  bottom: -21px;
  right: -20px;
}

.form-dis-radio2>>>.el-radio {
  margin-right: 0px;
}

.form-dis-box-radio2>>>.el-input__inner {
  /* width: 120px; */
  width: 80%;
  border-radius: 0 !important;
  border-top: 0 !important;
  border-left: 0 !important;
  border-right: 0 !important;
  height: 20px !important;
  padding: 0 !important;
  padding-left: 3px !important;
}

.form-dis-box-radio2>>>.el-form-item__content {
  line-height: 20px !important;
}

/* 1 */
.form-item {
  margin-top: 18px;
  background-color: #fff;
  border-radius: 6px;
  padding: 12px;
}

.box-dis {
  display: flex;
  flex-wrap: wrap;
  /* margin-bottom: 10px; */
  margin-bottom: 0;
}


.box-dis>>>.el-form-item__label {
  width: 100% !important;
  margin-bottom: 10px;
}

.box-dis>>>.el-form-item__content {
  margin-left: 0 !important;
}

.box-dis-input>>>.el-form-item__content {
  margin-left: 0 !important;
}

.box-dis>>>.el-form-item__error {
  top: 94% !important;
}

.box-dis2 {
  margin-bottom: 10px;
}

.box-bottom-15 {
  width: 321px;
  margin-bottom: 10px;
}

.btn {
  margin-top: 38px;
}

.btn-form>>>.el-form-item__content {
  margin-left: 0 !important;
}

.dibu {
  display: flex;
  align-items: center;
  margin-top: 30px;
  margin-bottom: 10px;
}

.dibu-img {
  width: 17px;
  height: 17px;
  margin-right: 4px;
}

.dibu-name {
  color: #000000;
  font-size: 15px;
}

.form-item-error>>>.el-form-item__error {
  min-width: 375px !important;
  top: 80% !important;
}
</style>      